




// Composition
import { defineComponent, computed, useRouter } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

// Composables
import useSearchUrl from '@/composables/search/useSearchUrl'

// Store
import { useSearchStore } from '@/store/search'

// Components
import ResultsPerPage from '@/components/feature/search/nav/ResultsPerPage.vue'

export default defineComponent({
  components: {
    ResultsPerPage,
  },
  setup() {
    const searchStore = useSearchStore()
    const { getResults: results, page } = storeToRefs(searchStore)
    const resultsPerPage = computed(() => page.value.resultsPerPage)
    const { getSearchUrl } = useSearchUrl()
    const router = useRouter()

    // Listen to click from the child component
    const adjustResultsPerPage = (nr: number) => {
      // set local var
      searchStore.setresultsPerPage(nr)

      // set in store
      searchStore.setCurrentPage(1)

      // perform new search
      router.push(getSearchUrl())
    }

    return {
      resultsPerPage,
      adjustResultsPerPage,
      results,
    }
  },
})
